import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import PreviewTemplate from "./PreviewTemplate";
import { useFillColorInDesign } from "../../_actions/bot";
import log from "cslog";
import { queryClient } from "../../_helpers/query";

function ColorAITest({ item, me, isMobile, preset }) {
    const [open, setOpen] = useState(false);
    const [selected_item, setSelectedItem] = useState(null);

    const mutation = useFillColorInDesign(
        (result) => {
            log.d(result, "result in CAIT");
            if (result?.success) {
                setOpen(true);
                setSelectedItem(result?.data?.data);

                queryClient.invalidateQueries(["items", "qp_creation"]);

                queryClient.invalidateQueries([
                    "items",
                    "qp_published_creation",
                ]);
            }
        },
        () => {}
    );

    // useEffect(() => {
    //     if (item) {
    //         setSelectedItem(item);
    //     }
    // }, [item]);

    log.d(selected_item, "selected_item in CAIT");

    return (
        <div>
            <Button
                onClick={() => {
                    // setOpen(true);
                    mutation.mutate({
                        id: item.id,
                        palette: {
                            name: "default",
                            secondryColor: "#0a46a5",
                            primaryColor: "#c9ddfc",
                            primaryColor2: "#a6b9fc",
                            neutralColor: "#191919",
                            neutralColor2: "#e5e5e5",
                            accentColor: "#99003b",
                            rank: 1,
                            theme: "light",
                        },
                        fix_readibility: true,
                    });
                }}
                loading={mutation.isLoading}
            >
                Color with AI
            </Button>

            {selected_item && (
                <PreviewTemplate
                    item={selected_item}
                    open={open}
                    setOpen={setOpen}
                    is_template={false}
                    slug_field="slug"
                    enable_img_preview={false}
                    me={me}
                    isMobile={isMobile}
                    preset={preset}
                />
            )}
        </div>
    );
}

export default ColorAITest;
